module.exports = __webpack_public_path__ + "static/new_session_list-f903a8e78c898b74d11a5b31facdd418.png";